<div class="container h-100 text-center d-flex flex-column align-items-center justify-content-center">
  <div class="display-1 fw-bolder">404</div>
  <div class="h3 fw-bold">Not Found</div>
  <button class="btn btn-dark mt-3" routerLink="">Go Home</button>
</div>
